module.exports = __webpack_public_path__ + "img/22.f39017e8.png";